import { render } from "./ShowInspect.vue?vue&type=template&id=74f8b89b"
import script from "./ShowInspect.vue?vue&type=script&lang=js"
export * from "./ShowInspect.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/customer/quality_control/destination/show_inspect.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Fquality_control%2Fdestination%2FShowInspect.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/models/quality_inspect.yml?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Fquality_control%2Fdestination%2FShowInspect.vue&lang=yaml"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__